<template lang="pug">
li
  a(@click="itemClick") {{ subLink.name }}
</template>

<script>
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "Sublink",
  mixins: [mixins],
  props: {
    subLink: Object,
  },
  methods: {
    itemClick() {
      this.linkClick(this.subLink);
      this.$emit("hideSubMenu");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/sublink";
</style>
